import { AgentPublicBio } from "model/agent";

export const isUrl = (s: string): boolean => {
	if (!s) return true; // Empty is valid
	return /^https?:\/\/\S+$/i.test(s);
};

export const stripHtml = (s: string): string => {
	return (s || '').replace(/<[^>]*>/g, '');
};

export const visibleLen = (s: string | null | undefined): number => {
	return stripHtml(s || '').trim().length;
};

export interface ValidationErrors {
	[key: string]: string;
}

export function validate(state: AgentPublicBio): ValidationErrors {
	const errors: ValidationErrors = {};

	// Header section validation
	if (state.showHeader) {
		if (!state.heroImage) {
			errors.heroImage = 'Hero image is required when header is enabled.';
		}
	}

	if (state.pageHeaderText && visibleLen(state.pageHeaderText) > 120) {
		errors.pageHeaderText = 'Max 120 characters.';
	}

	if (state.aboutBody && visibleLen(state.aboutBody) > 5000) {
		errors.aboutBody = 'Max 5000 characters.';
	}

	// Social links validation
	const socialFields: Array<keyof AgentPublicBio> = [
		'linkedinUrl',
		'facebookUrl',
		'instagramUrl',
		'twitterUrl',
		'tiktokUrl'
	];

	socialFields.forEach((field) => {
		const value = state[field] as string | undefined;
		if (value && !isUrl(value)) {
			errors[field] = 'Enter a valid URL or leave empty.';
		}
	});

	// Testimonials validation
	(state.testimonials || []).forEach((t, i) => {
		if (!t.quote?.trim()) {
			errors[`testimonials.${i}.quote`] = 'Quote is required.';
		}
		if ((t.quote || '').length > 600) {
			errors[`testimonials.${i}.quote`] = 'Max 600 characters.';
		}
		if (!t.author?.trim()) {
			errors[`testimonials.${i}.author`] = 'Author is required.';
		}
		if ((t.author || '').length > 120) {
			errors[`testimonials.${i}.author`] = 'Max 120 characters.';
		}
	});

	return errors;
}

export const validateImageFile = (file: File): string | null => {
	const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
	const maxSize = 25 * 1024 * 1024; // 25MB

	if (!validTypes.includes(file.type)) {
		return 'Please upload a valid image file (JPG, JPEG, PNG, or WEBP).';
	}

	if (file.size > maxSize) {
		return 'File size must be less than 25MB.';
	}

	return null;
};
